import React from "react"
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar"
import "react-pro-sidebar/dist/css/styles.css"

import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import { navigate } from "gatsby"

import "./mobileMenu.scss"

export const renderMenu = (items, level) => {
  return items.map((item, index) => {
    if (item.bool_is_visible) {
      if (item.children.length > 0) {
        return (
          <ProSidebar key={index}>
            <SubMenu
              className={level === 1 ? "level-1" : ""}
              title={item.text_label}
            >
              <MenuItem
                className="overview"
                onClick={() => navigate(item.text_page_url)}
              >
                {`'${item.text_label}' főoldal megtekintése`}
              </MenuItem>
              {item.children && renderMenu(item.children, level + 1)}
            </SubMenu>
            {level > 0 ? <ExpandMoreIcon className="down-arrow" /> : null}
          </ProSidebar>
        )
      } else {
        if (item.bool_is_external) {
          return (
            <MenuItem key={index}>
              <a
                href={item.text_page_url}
                key={index}
                target={"__blank"}
                rel={"noopener noreferrer"}
              >
                {item.text_label}
              </a>
            </MenuItem>
          )
        } else {
          return (
            <MenuItem key={index} onClick={() => navigate(item.text_page_url)}>
              {item.text_label}
            </MenuItem>
          )
        }
      }
    } else {
      return <span key={index}></span>
    }
  })
}

const MobileMenu = (props) => {
  return (
    <ProSidebar>
      <Menu iconShape="square">{renderMenu(props.items, 0)}</Menu>
    </ProSidebar>
  )
}

export default MobileMenu
